var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.63281 4.75H7.84375C8.40625 4.75 8.71094 4.07031 8.28906 3.64844L5.19531 0.460938C5.07812 0.320312 4.91406 0.25 4.75 0.25C4.58594 0.25 4.39844 0.320312 4.28125 0.460938L1.1875 3.64844C0.765625 4.07031 1.07031 4.75 1.63281 4.75ZM7.84375 6.25H1.63281C1.07031 6.25 0.765625 6.95312 1.1875 7.375L4.28125 10.5625C4.39844 10.7031 4.5625 10.75 4.75 10.75C4.91406 10.75 5.07812 10.7031 5.19531 10.5625L8.28906 7.375C8.71094 6.95312 8.40625 6.25 7.84375 6.25Z",
    fill: "#464B55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/SortIcon.8eb4cdbeeadae1c94366035cae6363b9.svg";
export { ForwardRef as ReactComponent };